import React, { useState } from 'react';

import ShortenUrlForm from '../components/ShortenUrlForm';
import ShortenAgainForm from '../components/ShortenAgainForm';
import ShortenUrlResult from '../components/ShortenUrlResult';
import MyserviceArea from '../components/MyserviceArea';
import InformationArea from '../components/InformationArea';


const Home = () => {

  const [inputUrl, setInputUrl] = useState('');
  const [afterUrl, setAfterUrl] = useState('');

  // 子コンポーネントから受け取ったURLを処理(更に短縮用)
  const handleProcessUrl = (url) => {

    // 36進数の短縮URLを生成    
    if (url.startsWith('https://ffxiv.link/')) {
      // 2. サイトURLを除去
      const numUrl = url.replace('https://ffxiv.link/', '');
      const siteType = numUrl.substr(0, 1);
      const siteNum = Number(numUrl.substr(1));

      // 3. 数値か検証
      if (!isNaN(siteNum)) {
        // 4. 短縮URLを生成
        const setNum = siteNum.toString(36);
        let newSiteType = '';
        if (siteType === '0') {
          newSiteType = 'a';
        } else if (siteType === '1') {
          newSiteType = 'b';
        } else if (siteType === '2') {
          newSiteType = 'c';
        } else if (siteType === '3') {
          newSiteType = 'd';
        }
        const generatedUrl = `https://ffxiv.link/${newSiteType}${setNum}`;

        // 5. 子コンポーネントに結果を渡す
        setInputUrl(url);
        setAfterUrl(generatedUrl)
      } else {
        console.log('error');
      }
    } else {
      console.log('error');
    }
  };

  // 更に短縮をリセットする
  const handleinputUrl = () => {
    setInputUrl('');
  };

  return (
    <main>
      <ShortenUrlForm />
      <section id="short_area">
        <div id="short_area_inner">
          {/* handleProcessUrl関数をpropsとして渡す */}
          {!inputUrl && <ShortenAgainForm onProcess={handleProcessUrl} />}
          {/* afterUrlとinputUrlをpropsとして渡す */}
          {inputUrl && <ShortenUrlResult inputUrl={inputUrl} afterUrl={afterUrl} onMoreProcess={handleinputUrl} />}
        </div>
      </section>
      <MyserviceArea />
      <InformationArea />
    </main>
  );
};

export default Home;